import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import { sucursalToString } from "app/logic/sucursal";
import { assertUnreachable } from "keautils";

/**Valida el FXC, devuelve true si no hay ningún error, si no, devuelve el mensaje de error */
export async function validarFXC(x: models.ServiciosAdicionales, servicio: models.ServicioDocumentacion) {
    if (!x.FletePorCobrar) return true;
    const val = await resources.Documentacion.ValidarFXC(x, servicio.IdSucursalDestino, servicio.IdDireccionDestino);
    return (
        val == null ? true :
            val == models.ErrorFletePorCobrar.DestinoNo ? "El cliente no acepta FXC " :
                val == models.ErrorFletePorCobrar.DestinoNoZE ? "El cliente no acepta FXC para ZEs" :
                    "Error indefinido"
    );
}

/**Devuelve true si el valor del folio PP es válido */
export async function validarFolioPP(folioPP: string | null, tipo: models.TipoServicio): Promise<true | string> {
    if (folioPP == "" || folioPP == null)
        return true;
    const regex = /^[A-Z0-9]{3}-[0-9]{4}$/g;
    if (!regex.test(folioPP))
        return "Formáto inválido";

    //Validar en el backend: 
    const errorBE = await resources.Documentacion.ValidarFolioPPDocu(tipo, folioPP);
    const ret =
        errorBE == null ? true :
            errorBE == models.ErrorFolioPPDocumentacion.NoExiste ? "Guia PP no existe" :
                errorBE == models.ErrorFolioPPDocumentacion.FacturaSinPagar ? "factura no pagada" :
                errorBE == models.ErrorFolioPPDocumentacion.PaquetePPCancelado ? "Paquetepp cancelado" :
                    errorBE == models.ErrorFolioPPDocumentacion.Gastado ? "Guia PP gastada" :
                        errorBE == models.ErrorFolioPPDocumentacion.ServicioNoAplica ? (
                            tipo == models.TipoServicio.Paquete ? "No aplica para paquete" :
                                tipo == models.TipoServicio.Sobre ? "No aplica para sobre" :
                                    assertUnreachable(tipo)
                        ) :
                            assertUnreachable(errorBE);    
    return ret;
}

export async function validarFolioPPConServicios(folioPP: string, tipo: models.TipoServicio): Promise<models.ErrorFolioPPDocumentacionConServiciosAdicionales> {
    //Validar en el backend: 
    const errorBE = await resources.Documentacion.ValidarFolioPPDocuConServicios(tipo, folioPP);
 
    const ret =
        errorBE.error == null ? true :
            errorBE.error == models.ErrorFolioPPDocumentacion.NoExiste ?  "Guia PP no existe" :
                errorBE.error == models.ErrorFolioPPDocumentacion.FacturaSinPagar ? "factura no pagada" :
                errorBE.error == models.ErrorFolioPPDocumentacion.PaquetePPCancelado ? "Paquetepp cancelado" :
                    errorBE.error == models.ErrorFolioPPDocumentacion.Gastado ? "Guia PP gastada" :
                        errorBE.error == models.ErrorFolioPPDocumentacion.ServicioNoAplica ? (
                            tipo == models.TipoServicio.Paquete ? "No aplica para paquete" :
                                tipo == models.TipoServicio.Sobre ? "No aplica para sobre" :
                                    assertUnreachable(tipo)
                    ) :
                        assertUnreachable(errorBE.error);
    return errorBE//ret;
}

export async function arreglarGuiaPP<T extends models.ServicioDocumentacion>(next: T, tipo: models.TipoServicio): Promise<T> {
    if (next.FolioGuiaPP) {
        const valido = await validarFolioPP(next.FolioGuiaPP, tipo);
        if (valido) {
            const serviciosAdicionales = await resources.Documentacion.ObtenerServiciosAdicionalesFolioPPDocu(next.FolioGuiaPP);
            return {
                ...(next as any),
                Cantidad: 1,
                ServiciosAdicionales: {
                    Acuse: serviciosAdicionales.Acuse,
                    EntregaDomicilio: serviciosAdicionales.EntregaDomicilio,
                    FletePorCobrar: false,
                    RecoleccionDomicilio: serviciosAdicionales.RecoleccionDomicilio,
                    ServicioEspecial: serviciosAdicionales.ServicioEspecial,
                    ValorDeclarado: serviciosAdicionales.ValorDeclarado,
                    ValorFactura: serviciosAdicionales.ValorFactura
                }
            }
        }
    }
    return next;
}

export async function arreglarGuiaPPNuevo<T extends models.ServicioDocumentacion>(next: T, tipo: models.TipoServicio): Promise<T> {
    if (next.FolioGuiaPP) {
        const regex = /^[A-Z0-9]{3}-[0-9]{4}$/g;
        if ( !( next.FolioGuiaPP == "" || next.FolioGuiaPP == null) && regex.test(next.FolioGuiaPP) )
        {
            console.log( "Paso validacion" );
            const valido = await validarFolioPPConServicios(next.FolioGuiaPP, tipo);

            
            console.log("Saca Valido");
            console.log( valido );

            if (valido.error == null) {
                console.log("Entra Valido");
                console.log( valido );
                const serviciosAdicionales =  valido.servicios; //await resources.Documentacion.ObtenerServiciosAdicionalesFolioPPDocu(next.FolioGuiaPP);
                return {
                    ...(next as any),
                    Cantidad: 1,
                    ServiciosAdicionales: {
                        Acuse: serviciosAdicionales.Acuse,
                        EntregaDomicilio: serviciosAdicionales.EntregaDomicilio,
                        FletePorCobrar: false,
                        RecoleccionDomicilio: serviciosAdicionales.RecoleccionDomicilio,
                        ServicioEspecial: serviciosAdicionales.ServicioEspecial,
                        ValorDeclarado: serviciosAdicionales.ValorDeclarado,
                        ValorFactura: serviciosAdicionales.ValorFactura
                    }
                }
            }
        }        
    }
    return next;
}

/**
 * Valida la cobertura de ruta de EAD para un servicio de documentación
 * @param x 
 */
export async function validarCoberturaEAD(x: models.ServicioDocumentacion) {
    if (!x.ServiciosAdicionales.EntregaDomicilio) {
        return true;
    }
    if (x.IdSucursalDestino == null || x.IdDireccionDestino == null) {
        return true;
    }
    const hayCobertura = await resources.Documentacion.TieneCoberturaEAD(x.IdDireccionDestino, x.IdSucursalDestino);
    if (!hayCobertura) {
        return "No hay cobertura de EAD para este código postal";
    }

    return true;
}

/**Obtiene un arreglo de cadenas con las descipciones de los servicios adicionales */
export function obtenerDescripcionesServiciosAdicionales(x: models.ServiciosAdicionales | undefined): string[] {
    x = x || {};
    let ret: string[] = [];
    if (x.EntregaDomicilio) {
        ret.push("Entrega domicilio");
    }
    if (x.RecoleccionDomicilio) {
        ret.push("Recolección a domicilio");
    }
    if (x.FletePorCobrar) {
        ret.push("Flete por cobrar");
    }
    if (x.ValorDeclarado) {
        ret.push("Seguro con valor declarado de " + kea.formatCurrency(x.ValorDeclarado));
    }
    if (x.Acuse != null) {
        ret.push("Acuse " + models.TipoAcuse[x.Acuse]);
    }
    if (x.ValorFactura != null) {
        ret.push("Cobro de otros servicios " + kea.formatCurrency(x.ValorFactura));
    }

    return ret;
}

function esPaquete(x: models.SobreDocumentacion | models.PaqueteDocumentacion): x is models.PaqueteDocumentacion {
    return (x as models.PaqueteDocumentacion).Peso != undefined;
}

export async function setDescripciones(x: models.PaqueteDocumentacion): Promise<models.PaqueteDocumentacion>
export async function setDescripciones(x: models.SobreDocumentacion): Promise<models.SobreDocumentacion>
export async function setDescripciones(x: models.SobreDocumentacion | models.PaqueteDocumentacion): Promise<models.SobreDocumentacion | models.PaqueteDocumentacion> {
    const direccion = await resources.Cliente.GetDireccion(x.IdDireccionDestino);
    const suc = await resources.Sucursal.getMemo(x.IdSucursalDestino);
    const desDireccion = direccion.Direccion.Descripcion;
    const nombreCliente = direccion.Cliente.Nombre;
    const comunes: models.SobreDocumentacion | models.PaqueteDocumentacion = {
        ...x,
        DescripcionDestino: desDireccion,
        NombreCliente: nombreCliente,
        NombreSucursal: sucursalToString(suc)
    }

    if (esPaquete(x)) {
        const contenidoPaquete = await resources.ContenidoPaquete.getMemo(x.IdContenidoPaquete);
        const descPaquete = await resources.DescripcionPaquete.getMemo(x.IdDescripcionPaquete);


        return { ...comunes, NombreContenidoPaquete: contenidoPaquete.Nombre, NombreDescripcionPaquete: descPaquete.Nombre } as models.PaqueteDocumentacion;
    } else {
        const contenidoSobre = await resources.ContenidoSobre.getMemo(x.IdContenidoSobre);
        return { ...comunes, NombreContenidoSobre: contenidoSobre.Nombre }
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/logic.tsx